import styled from "styled-components";

const StyledContent = styled.div`
  max-width: 700px;
  margin-top: 21px;
`;

export default StyledContent;
